import * as React from "react";
import PropTypes from "prop-types";
import Loadable from "react-loadable";
import ErrorPage from "nexia_mobile/components/Pages/ErrorPage";
import SpinnerOverlay from "nexia_mobile/components/SpinnerOverlay";
import Page from "nexia_mobile/components/Page";
import AppBarWrapper from "nexia_mobile/components/TopBar/AppBarWrapper";
import CommonAppBarContainer from "nexia_mobile/components/TopBar/CommonAppBarContainer";

export default class Loading extends React.Component {
  static propTypes = {
    error: PropTypes.instanceOf(Error),
    pastDelay: PropTypes.bool,
    timedOut: PropTypes.bool,
  };

  render() {
    const { error, pastDelay, timedOut } = this.props;
    if (error || timedOut) {
      return <ErrorPage />;
    }

    return (
      <Page name="Loading" fullyLoaded={false}>
        {/*
          Most pages have an AppBar, so render an empty one
          during the flash of loading page
        */}
        <AppBarWrapper>
          <CommonAppBarContainer title="" iconRight={null} iconLeft={null} />
        </AppBarWrapper>
        {/*
          Avoid flash of spinner if loading takes less than
          the configured delay (defaults to 200ms)
        */}
        {pastDelay ? <SpinnerOverlay /> : null}
      </Page>
    );
  }
}

export function makeLoaderComponent(promiseFunc) {
  return Loadable({
    loader: promiseFunc,
    loading: Loading,
  });
}



// WEBPACK FOOTER //
// ./src/components/Routing/Loading.jsx